export default {
	PreviewEditMap: [
		// {			
		// 	MenuId: 0,
		// 	RouteName: "AdminEvent",
		// 	RoutePath: "/admin-event/{{EventId}}",
		// 	AdminRouteName: "EventSetup",
		// 	AdminRoutePath: "/eventsetup",
		// 	IsPublished: true,
		// },
		// {			
		// 	MenuId: 0,
		// 	RouteName: "AdminEvent",
		// 	RoutePath: "/admin-event/{{EventId}}",
		// 	AdminRouteName: "EvenBranding",
		// 	AdminRoutePath: "/evenbranding",
		// 	IsPublished: true,
		// },
		{
			MenuId: 0,
			RouteName: "Eventv3",
			RoutePath: "/eventv3",
			AdminRouteName: "AdminEvent",
			AdminRoutePath: "/admin-event",
			IsPublished: true,
		},
		{
			MenuId: 0,
			RouteName: "Analytics",
			RoutePath: "/overview",
			AdminRouteName: "Analytics",
			AdminRoutePath: "/overview",
			IsPublished: true,
		},
		{
			MenuId: 1002,
			RouteName: "Sessions",
			RoutePath: "/sessions",
			AdminRouteName: "AdminSessions",
			AdminRoutePath: "/admin-sessions",
			IsPublished: true,
		},
		{
			MenuId: 1001,
			RouteName: "AttendeeList",
			RoutePath: "/attendee",
			AdminRouteName: "AdminAttendeeList",
			AdminRoutePath: "/admin-attendee",
			IsPublished: true,
		},
		{
			MenuId: 1005,
			RouteName: "SpeakerList",
			RoutePath: "/speakers",
			AdminRouteName: "AdminSpeakerList",
			AdminRoutePath: "/admin-speakers",
			IsPublished: true,
		},
		{
			MenuId: 1004,
			RouteName: "RoundtableList",
			RoutePath: "/roundtable",
			AdminRouteName: "AdminRoundtableList",
			AdminRoutePath: "/admin-roundtable",
			IsPublished: true,
		},
		{
			MenuId: 1030,
			RouteName: "StageView",
			RoutePath: "/stageview",
			AdminRouteName: "AdminStageView",
			AdminRoutePath: "/admin-stageview",
			IsPublished: true,
		},
		{
			MenuId: 1003,
			RouteName: "Exbitorshall",
			RoutePath: "/exhibitorshall",
			AdminRouteName: "AdminExbitorshall",
			AdminRoutePath: "/admin-exhibitorshall",
			IsPublished: true,
		},
	]
}